import Flex from '@hds-routing/component-library/Flex';
import Progress from '@hds-routing/component-library/Progress';
import { Link } from 'react-router-dom';

import config from 'app/config';

const NotFound = () => {
    const isRedirecting = Boolean(
        window.location.href.includes(config.nextURI)
    );

    return (
        <Flex
            align="center"
            css={{ height: '100vh' }}
            fullWidth
            justify="center"
        >
            {isRedirecting ? (
                <Progress
                    color="secondary"
                    css={{
                        maxWidth: '200px',
                    }}
                    hidePercentage={true}
                    value={0}
                    variant="indeterminate"
                />
            ) : (
                <div css={{ textAlign: 'center' }}>
                    <h1>Route Not Found</h1>
                    <Link to="/">Go to Dashboard</Link>
                </div>
            )}
        </Flex>
    );
};

export default NotFound;
